import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { CoachPositionIndexView } from '../../../types/coachPositions';
import { CoachPositionReservationApis, UserCoachPositionApis } from '../../../apis/coachPositions';
import { DialogState } from '../../../../commonv3/states/dialogState';
import { CoachPositionId } from '../../../../adminv3/types/session';
import { SubmitState } from '../../../../commonv3/states/SubmitState';

export class TimesheetPageState {
    @observable reservedPositions: RemoteResourceV3<CoachPositionIndexView[]> = RemoteResourceV3.loading();
    @observable cancellationDialog = new DialogState(false);
    @observable selectedPositionId: CoachPositionId = null;
    @observable submitState: SubmitState = new SubmitState();

    @action.bound
    async init() {
        await updateRemoteResourceV3(
            this.reservedPositions,
            (v) => (this.reservedPositions = v),
            () => UserCoachPositionApis.findAll()
        );
    }

    @action.bound
    requestCancellation(id: CoachPositionId) {
        this.selectedPositionId = id;
        this.cancellationDialog.open();
    }

    @action.bound
    async submitCancellation() {
        if (!this.selectedPositionId) {
            return;
        }
        await this.submitState.operate(async () => {
            try {
                await CoachPositionReservationApis.delete(this.selectedPositionId);
                await this.init();
            } catch (e) {
                alert('キャンセルに失敗しました。');
                throw e;
            } finally {
                this.cancellationDialog.close();
            }
        });
    }
}
